export function Deg2Rad(theta: number) : number {
    return theta * Math.PI / 180;
}